import { useApplicationStore } from '@data';
import { Events, tracking } from '@lib';
import { LoaderFunctionArgs, redirect } from 'react-router-dom';
import { HOME_ROUTE_PATHNAME } from '@router/routes/routePathnames';
import { buildLeadSessionId } from '@utils';
import { getStateForCurrentLocation, loadServiceTypesByState } from './utils';
import { captureException } from '@sentry/react';

const REFERRAL_CODE_QUERY_PARAM = 'code';
export const REFERRAL_SERVICE_QUERY_PARAM = 'service';

export async function referralLoader({ request }: LoaderFunctionArgs) {
  const url = new URL(request.url);
  const referralCode = url.searchParams.get(REFERRAL_CODE_QUERY_PARAM);
  const serviceAbbreviation = url.searchParams.get(
    REFERRAL_SERVICE_QUERY_PARAM,
  );

  if (!referralCode || !serviceAbbreviation) {
    return redirect(HOME_ROUTE_PATHNAME);
  }

  const {
    setStateCode,
    setReferralCode,
    setLeadSessionId,
    getServiceTypeByAbbreviation,
  } = useApplicationStore.getState();
  const leadSessionId = buildLeadSessionId();

  setLeadSessionId(leadSessionId);
  setReferralCode(referralCode);

  try {
    const detectedState = await getStateForCurrentLocation();

    if (detectedState) {
      tracking.trackEvent(Events.SELECT_STATE, { AutoSelected: true });
      tracking.setBaseProperty({ selectedState: detectedState });
      setStateCode(detectedState);

      await loadServiceTypesByState(detectedState);

      const serviceType = getServiceTypeByAbbreviation(serviceAbbreviation);

      if (serviceType) {
        tracking.setBaseProperty({ serviceTypeId: serviceType.serviceTypeId });
      } else {
        captureException(
          new Error(
            `Service type not found for abbreviation: ${serviceAbbreviation}`,
          ),
        );

        return redirect(HOME_ROUTE_PATHNAME);
      }
    } else {
      captureException(new Error('Failed to detect visitor state'));
      return redirect(HOME_ROUTE_PATHNAME);
    }
  } catch (error) {
    captureException(error);
    return redirect(HOME_ROUTE_PATHNAME);
  }

  return null;
}
